export default __webpack_public_path__ + "static/media/Zoe_9781846168901.acc9c43e.jpg";